export const USER_TYPE_PATIENT = 0
export const USER_TYPE_PHARMACIST = 1
export const USER_TYPE_OTHER = 2

export const OWNER_PARTICIPANT_PENDING = 1
export const OWNER_PARTICIPANT_ACCEPT = 2
export const OWNER_PARTICIPANT_CANCEL = 3

export const MEETING_CANCELED = 0
export const MEETING_PENDING = 1

export const PENDING = 'pending'
export const CANCEL = 'cancel'
export const ACCEPT = 'accept'
export const MEETING_ENDING = 'end'

export const CANCEL_TYPE_REJECT = 'reject'
export const CANCEL_TYPE_CANCEL = 'cancel'

export const MEETING_CATEGORY_MEDICATION_INSTRUCTION_ID = 1

export const MEETING_CATEGORY_MEDICATION = 'reservation'
export const MEETING_CATEGORY_ONLINE = 'online'

export const USER_TYPES = [
  {value: 0, label: '患者'},
  {value: 1, label: '薬剤師'}
  // {value: 2, label: '多職種'}
]

export const VIDEO_RESOLUTIONS = [
  { videoProfile: '180p', resolution: '240 x 180', fps: 15, kbps: 120, key: '240x180' },
  { videoProfile: '240p', resolution: '320 x 240', fps: 15, kbps: 200, key: '320x240' },
  { videoProfile: '360p', resolution: '480 x 360', fps: 15, kbps: 320, key: '480x360' },
  { videoProfile: '360px', resolution: '640 x 360', fps: 15, kbps: 600, key: '640x360' },
  { videoProfile: '480p', resolution: '640 x 480', fps: 15, kbps: 400, key: '640x480' },
  { videoProfile: '720px', resolution: '960 x 720', fps: 15, kbps: 400, key: '960x720' },
  { videoProfile: '720p', resolution: '1280 x 720', fps: 15, kbps: 1130, key: '1280x720' }
]

export const PAYMENT_TEMPORARILY_SAVED = 0
export const PAYMENT_REQUESTED = 1
export const PAYMENT_REQUESTED_CASH_ON_DELIVERY = 2
export const PAYMENT_COMPLETED = 3
export const PAYMENT_EXPIRED = 4
export const PAYMENT_ERROR = 5
export const PAYMENT_CANCELED = 6
export const PAYMENT_REQUESTED_CREATE_INVOICE = 7
export const PAYMENT_REQUESTED_SETTING_SHIPPING_ADDRESS = 8
export const PAYMENT_AKADEN = 9
export const PAYMENT_NO_EXISTS_DATA = -1

export const MEETING_CATEGORY_GUIDANCE = 1
export const MEETING_CATEGORY_FOLLOW_UP = 2
export const MEETING_CATEGORY_MULTIPLE = 3
export const MEETING_CATEGORY_TEST = 4

export const BUTTONS_NONE = 0
export const BUTTONS_ONLINE_PAYMENT = 1
export const BUTTONS_PAYMENT_METHOD = 2
export const BUTTONS_SHIPPING_ADDRESS = 3
export const BUTTONS_PAYMENT_DETAIL = 4
export const BUTTONS_CREATE_INVOICE = 5
export const BUTTONS_INVOICE_DETAIL = 6



// WEBPACK FOOTER //
// ./src/const/index.js